module.exports = __webpack_public_path__ + "img/google_maps.de53b048.svg";